import { executeRequest, JFSRequest } from '@jfs/network'
import { isSuccessResponse } from '../utils'
import { APIEndPoints } from './APIEndPoints'
import { getHeaders, getUrl, sitConfig } from './config'
const responseParser = (response: any) => {
  const data = isSuccessResponse(response)
  return (
    data?.response
      // ?.filter((device: any) => device.linkingStatus === 'ACTIVE')
      ?.map((item: any, index) => {
        return {
          id: JSON.stringify(item?.id ?? index),
          sMid: item?.sMid ?? 'NA',
          mid: item?.mid ?? 'NA',
          tid: item?.tid ?? 'NA',
          dsn: item?.deviceid ?? 'NA',
          linkedDeviceId: item?.linkedDeviceId ?? 'NA',
          status: item.status ?? 'NA',
          link: item.status === 'ACTIVE' ? 'Delink' : '',
          createdDate: item?.createdDate ?? 'NA',
          deviceType: item?.deviceType,
        }
      })
  )
}
const searchDeviceMappings = (req: any, tokens: any) => {
  const request: JFSRequest<{}> = {
    apiPath: getUrl(APIEndPoints.searchDeviceMappings),
    method: 'POST',
    cache: false,
    config: sitConfig(tokens),
    headers: getHeaders(),
    body: req,
  }
  return executeRequest(request)
    .then(responseParser)
    .catch((error) => {
      throw error
    })
}
export { searchDeviceMappings }
